module.exports = __webpack_public_path__ + "img/Original_Horizontal-white.8e199ac1.png";